import { DeleteOutlineRounded, EditOutlined, MoreVert, ReorderRounded } from '@mui/icons-material';
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';
import React, { useCallback, useState } from 'react';

interface CategoryContextMenuProps {
  setShowDeleteConfirmation: (val: boolean) => void;
  setEditingCategory: (val: boolean) => void;
  setReordering: (val: boolean) => void;
  setExpanded: (val: boolean) => void;
}

const CategoryContextMenu: React.FC<CategoryContextMenuProps> = ({
  setShowDeleteConfirmation,
  setEditingCategory,
  setReordering,
  setExpanded,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  }, []);

  return (
    <>
      <IconButton onClick={handleOpen} sx={{ width: '40px', height: '40px' }}>
        <MoreVert />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setExpanded(true);
            setEditingCategory(true);
          }}
          sx={{ marginBottom: 1 }}
        >
          <ListItemIcon>
            <Tooltip title="Edit category name" arrow>
              <EditOutlined fontSize="small" />
            </Tooltip>
          </ListItemIcon>
          <ListItemText primary="Edit Category" />
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setExpanded(true);
            setReordering(true);
          }}
          sx={{ marginBottom: 1 }}
        >
          <ListItemIcon>
            <Tooltip title="Reorder category questions" arrow>
              <ReorderRounded fontSize="small" />
            </Tooltip>
          </ListItemIcon>
          <ListItemText primary="Reorder Questions" />
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setShowDeleteConfirmation(true);
          }}
          sx={{ marginBottom: 1 }}
        >
          <ListItemIcon>
            <Tooltip title="Permanently delete this category" arrow>
              <DeleteOutlineRounded color="error" fontSize="small" />
            </Tooltip>
          </ListItemIcon>
          <ListItemText primary="Delete Category" />
        </MenuItem>
      </Menu>
    </>
  );
};

export default CategoryContextMenu;
